<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="3"
      >
        <v-container>
          <strong>{{ item.store_name }}</strong>
          <p class="my-n1">
            {{ item.store_addr1 }}
          </p>
          <p class="my-n1">
            {{ item.store_citystate }}
          </p>
          <p class="my-n1">
            {{ item.store_phone }}
          </p>
        </v-container>
        <v-container>
          <strong>{{ item.shipname }}</strong>
          <p class="my-n1">
            {{ item.shipaddr1 }}
          </p>
          <p class="my-n1">
            {{ item.shipcity + ', ' + item.shipstate + ', ' + item.shipzip }}
          </p>
        </v-container>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-container>
          <p class="my-n1">
            <strong>Account:</strong> {{ item.customer }}
          </p>
          <p class="my-n1">
            <strong>Invoice:</strong> {{ item.invoice }}
          </p>
          <p class="my-n1">
            <strong>Created:</strong> {{ formatDate(item.date_formatted, 'MMM Do, YYYY') }}
          </p>
          <p class="my-n1">
            <strong>Due:</strong> {{ item.due_formatted }}
          </p>
          <p class="my-n1">
            <strong>Status:</strong> {{ item.status }}
          </p>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Item
                </th>
                <th class="text-left">
                  Description
                </th>
                <th class="text-left">
                  Price
                </th>
                <th class="text-left">
                  Qty
                </th>
                <th class="text-left">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(detail, i) in item.details"
                :key="'detail' + detail.invoice + '-' + i"
              >
                <td>{{ detail.item }}</td>
                <td>{{ detail.descriptio }}</td>
                <td>${{ detail.price.toFixed(2) }}</td>
                <td>{{ detail.qty }}</td>
                <td>${{ (detail.qty * detail.price).toFixed(2) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row
      class="justify-end"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-list>
          <v-list-item
            class="my-n4"
          >
            <v-list-item-content>
              Subtotal
            </v-list-item-content>
            <v-list-item-content
              class="align-end"
            >
              ${{ item.subtotal.toFixed(2) }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="my-n4"
          >
            <v-list-item-content>
              Taxes
            </v-list-item-content>
            <v-list-item-content
              class="align-end"
            >
              ${{ item.taxtotal.toFixed(2) }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="my-n4"
          >
            <v-list-item-content>
              Total
            </v-list-item-content>
            <v-list-item-content
              class="align-end"
            >
              ${{ item.total.toFixed(2) }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="my-n4"
          >
            <v-list-item-content>
              Paid
            </v-list-item-content>
            <v-list-item-content
              class="align-end"
            >
              ${{ item.paid.toFixed(2) }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="my-n4"
          >
            <v-list-item-content>
              Balance
            </v-list-item-content>
            <v-list-item-content
              class="align-end"
            >
              ${{ item.balance }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'

  export default {
    name: 'PowInvoiceDetails',

    mixins: [basicMixin],
    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          balance: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
      }
    },

    computed: {
      // balance: function () {
      //   if (this.currentObject && this.currentObject.total) {
      //     return (this.currentObject.total - this.currentObject.paid).toFixed(2)
      //   }
      //   return 'NaN'
      // },
    },
    async created () {
      this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions(['getCloudTowerConfigMembers']),
      init () {
        console.log('Initializing component setting values!', this.item)
        this.formMode = 'read'
        // console.log(val)
        this.currentObject = { ...this.item }
        this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
    },

  }
</script>

<style>
</style>
